@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/border-radius";
@import "/src/variables/tokens";
@import "/src/variables/layout";
@import "/src/variables/breakpoints";

.btn {
  /* Theme Studio (--zv-btn-*, set by utils/partnerTheme.ts); the fallbacks are the shipped look. */
  border-radius: $zv-btn-radius--border-radius-pill; /* Figma audit: pill radius for text buttons */
  opacity: 1;
  background-color: $Brand-Primary;
  color: $zv-on-brand--White;
  font-family: $font-primary;
  font-size: $font-size-tiny; /* Figma audit: Inter Medium 18px */
  font-weight: $zv-btn-weight--font-weight-medium; /* Figma audit: 500 Medium */
  text-transform: $zv-btn-case--none;
  gap: $space-8; /* Figma audit: 8px gap for text buttons */
  letter-spacing: 0.3px;
  text-align: center;
  transition: opacity 0.2s ease-in-out;
  line-height: $line-height-140-heading;
  border: none;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation;

  &:hover,
  :focus {
    background-color: $Brand-Primary-Dark;
  }

  // cursor: pointer;
  // -moz-user-select: none;
  // -ms-user-select: none;
  // user-select: none;
  // -webkit-user-select: none;
  // -ms-touch-action: manipulation;
  // touch-action: manipulation;
  @media screen and (min-width: $breakpoint-tablet) {
    cursor: pointer;
  }
}



/* Disabled state — Figma audit: 30% opacity */
.btn:disabled {
  opacity: 0.3;
  pointer-events: none !important;
  cursor: not-allowed !important;
}

/* Loading state — keeps the button fully visible (un-dims the disabled state)
   while an async prerequisite is loading. Still non-clickable via `disabled`
   (pointer-events:none above stays in effect). */
.btnLoading {
  opacity: 1 !important;
  cursor: default !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btnSpinner {
  margin-right: $space-8;
}

/* Small size */
.btn-sm {
  padding: $space-8 $space-18;
  font-size: $font-size-h12;

  @media screen and (max-width: 600px) {
    padding: $space-6 $space-12;
  }
}

.btn-text {
  padding: $space-8 $space-40;
  font-size: $font-size-h14;
  background-color: transparent !important;
  outline: none !important;
  border: none !important;
  color: $zv-text-primary--Neutral-Darkest;
}

.btn-text:hover {
  background-color: $Brand-Primary-Light !important;
  color: $Brand-Primary !important;
}

.btn-select_fare {
  padding: $space-8 $space-12;
  font-size: $font-size-h12;
  white-space: nowrap;

  @media screen and (max-width: $breakpoint-mobile-max) {
    font-size: $font-size-h11;
  }

  @media (min-width: 300px) and (max-width: 395px) {
    padding: $space-6 $space-10;
  }
}

.btn-flight_cost {
  padding: $space-8 $space-24;
  font-size: $font-size-h12;
  white-space: nowrap;

  @media screen and (max-width: $breakpoint-mobile-max) {
    font-size: $font-size-h11;
  }

  @media (min-width: 300px) and (max-width: 395px) {
    padding: $space-8 $space-14 !important;
  }

}

/* Medium size — Figma audit: 8px 20px padding */
.btn-sm {
  padding: $space-8 $space-20;
  font-size: $font-size-xs-tiny;
}

/* Medium size — Figma audit: 8px 20px padding */
.btn-md {
  padding: $space-8 $space-40;
  font-size: $font-size-tiny;
}

.btn-md_slim {
  padding: $space-8 $space-20;
  font-size: $font-size-tiny;
}

/* Large size — Figma audit: 8px 20px padding */
.btn-lg {
  padding: $space-8 $space-20;
  font-size: $font-size-small;
}

/* Default */
.btn-default {
  color: $zv-on-brand--White;
  border: none;
}

/* Cancel */
.btn-cancel {
  opacity: 1;
  color: $White;
  background-color: $zv-error--Primary-ElectricViolet;
  border: none;
  outline: none;
}

.btn-newDefault {
  font-family: $font-primary;
  background-color: $Brand-Primary;
  color: $zv-on-brand--White;
  font-size: $font-size-h6;
  line-height: $line-height-140-heading;
  font-weight: var(--zv-btn-weight, #{$fw-medium});
  letter-spacing: 0%;
}

/* Confirm — Apply / Done / Show results in dialogs, filters and sheets. Unset it is
   the brand fill, like .btn-default; Theme Studio button.confirm = dark paints it in
   the partner's Secondary colour (--zv-confirm-bg): 40 tall, 14/600/20, a darker
   hover and a flat grey disabled state instead of the faded one. */
.btn-confirm {
  background-color: $zv-confirm-bg--Brand-Primary;
  color: $zv-on-brand--White;
  border: none;

  @include when-theme(button, confirm, dark) {
    min-height: $space-40;
    font-size: $fs-14;
    font-weight: $font-weight-semibold;
    line-height: $line-height-20;
    letter-spacing: 0;

    &:hover,
    &:focus-visible {
      background-color: color-mix(in srgb, #{$zv-confirm-bg--Brand-Primary} 85%, #{$Neutral-Darkest});
    }

    &:disabled {
      opacity: 1;
      background-color: $zv-disabled--Neutral-Lightest;
      box-shadow: inset 0 0 0 $border-width $zv-border--gray-88;
      color: $zv-text-muted--Neutral-Light;
    }
  }
}

/* Success */
.btn-success {
  background-color: $Success;
  color: $White;
  border: none;
}

.btn-error {
  background-color: $Error-Light !important;
  color: $Error;
  border: none;
  outline: none;
  cursor: pointer;
}

.btn-refresh_btn {
  padding: $space-8 $space-24 $space-10 $space-24;
  font-family: $font-primary;
  font-size: $font-size-h16;
  line-height: $nineteen-pixel;
  font-weight: $font-weight-regular;
  letter-spacing: 0.34px;
  text-align: center;
}

.btn-full_width {
  width: 100%;
  padding: $space-10 $space-40;
  cursor: pointer;
}


.btn-apply_btn {
  padding: $space-8 $space-24 $space-10 $space-24;
  border: $border-width solid $zv-border--gray-62;
  border-radius: $border-radius-33-33;
  font-family: $font-primary;
  font-size: $font-size-h16;
  line-height: $nineteen-pixel;
  font-weight: $font-weight-regular;
  letter-spacing: 0.34px;
  text-align: center;
  color: $zv-on-brand--White !important;

  @media screen and (max-width: $breakpoint-mobile-max) {
    font-size: $font-size-h11;
  }
}

/*Icon btn — Figma audit: 9999px for icon-only, 12px padding, 12px gap */
.btn-transparent {
  background-color: transparent !important;
  border: none;
  outline: none;
  border-radius: $border-radius-circle;
  padding: $space-12;
  gap: $space-12;

  @media (hover: hover) and (pointer: fine) {

    &:hover,
    &:active {
      background-color: $Brand-Primary-Light !important;
    }
  }

}


.btn-fullyTransparent {
  background-color: transparent !important;
  border: none;
  outline: none;
  border-radius: $border-radius-circle;

  // @media (hover: hover) and (pointer: fine) {

  //   &:hover,
  //   &:active {
  //     background-color: $Brand-Primary-Light !important;
  //   }
  // }

}

/* Secondary Button — Figma audit: fill $Neutral-Lightest, text $Neutral-Darkest */
.btn-secondary {
  background-color: $zv-control--Neutral-Lightest !important;
  color: $zv-text-primary--Neutral-Darkest;
  border: none;
  outline: none;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {

    &:hover,
    &:active {
      background-color: $zv-well-hover--Neutral-Lighter !important;
    }
  }


}

/* Tertiary Button — Figma audit: fill #FFFFFF, text $Neutral-Darkest, Regular 400 */
.btn-tertiary {
  background-color: $zv-control--White;
  color: $zv-text-primary--Neutral-Darkest;
  font-weight: $font-weight-regular;
  border: none;
  outline: none;

  &:hover,
  &:active {
    background-color: $Brand-Primary-Light !important;
    color: $Brand-Primary;
  }
}

.btn-newTertiary {
  background-color: $zv-control--Neutral-Lightest !important;
  color: $zv-text-primary--Neutral-Darkest !important;
  border: none;
  outline: none;

  &:hover,
  &:active {
    background-color: $zv-well-hover--Neutral-Lighter !important;
    color: $zv-text-primary--Neutral-Darkest !important;
  }
}

/* Disabled */
// .disabled {
//   // background-color: $Neutral-Lightest !important;
//   // color: $Neutral-Darkest;
//   cursor: not-allowed;
//   border: none;
//   outline: none;
// }

// .disabled:hover {
//   opacity: 50%;
//   // background-color: $Neutral-Lighter !important;
// }

/* ── CustomButton variant ── */
.btn-custom {
  padding: $space-8 $space-20;
  font-size: $fs-12;
  font-weight: $font-weight-bold;
  color: black;
  background-color: $yellow-49;
  text-transform: initial;
  margin-top: $space-20;
  align-self: center;
  box-shadow: none;
  border: none;

  &:hover,
  &:focus {
    background-color: $yellow-59;
  }
}

/* ── BtnWithTextAndIcon styles (merged) ── */
.iconBtn {
  width: 40px !important;
  height: 40px !important;
  padding: $space-10 !important;
  display: flex;
  place-items: center;
  align-items: center;
  justify-content: center;
}

.continueBtnContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  .continueBtn {
    text-transform: initial;
    font-weight: $font-weight-medium;
    font-family: $font-primary;
    margin-bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: $font-size-h16;

    .icon {
      height: 17px;
      padding-right: 0px;
      margin-left: 0px;
      padding-left: $space-10;
      margin-right: (-$space-20);
    }
  }

  .preIcon {
    & img {
      height: 17px;
      padding-left: 0;
      margin-right: 0;
    }
  }

  .refine {
    & img {
      height: 17px;
      padding-right: $space-10;
      margin-left: (-$space-10);
      padding-left: 0;
    }
  }

  & p {
    font-size: $font-size-h12;
    font-weight: $font-weight-regular;
    color: $zv-text-secondary--Font-Color;
    padding-top: $space-8;
  }
}
.btn-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: $space-3xs;
  box-sizing: border-box;
  min-height: $control-height-pill;
  padding: $space-xs $space-sm $space-xs $space-md;
  font-size: $font-size-xs-tiny;
  font-weight: $fw-medium;
  letter-spacing: 0;
}

/* Theme Studio — the primary buttons' style. Solid (no attribute) is the shipped look.
   :where() keeps these at the specificity of .btn's own fill, so any screen that
   restyles an AppButton (tabs, ghost buttons) still wins, exactly as it does today. */
:global(:where(html[data-zv-btn-style="outline"])) {
  .btn-default,
  .btn-newDefault {
    background-color: transparent;
    color: $Brand-Primary;
    box-shadow: inset 0 0 0 1.5px $Brand-Primary;

    &:hover {
      background-color: $Brand-Primary-Light;
    }
  }
}

:global(:where(html[data-zv-btn-style="soft"])) {
  .btn-default,
  .btn-newDefault {
    background-color: $Brand-Primary-Light;
    color: $Brand-Primary;

    &:hover {
      background-color: $Brand-Primary-Light;
      filter: brightness(0.96);
    }
  }
}
